<template>
	<div class="panel">
		<div class="panel-header">Campaign Metrics<a class="text-primary cursor-pointer float-right"
													 @click.prevent="toggleExpand"><span v-if="!expanded">View More Details<i
				class="fa fa-angle-down ml-2"></i></span><span v-if="expanded">Show Less Details<i
				class="fa fa-angle-up ml-2"></i></span></a></div>
		<div
				class="panel-body" style="min-height: 169px;">
			<div class="row">
				<div class="col">
					<count-metric title="Invites Sent" :count="data.contacts_sent ? data.contacts_sent : 0"/>
				</div>
				<div class="col d-flex justify-content-center">
					<percent-metric :title="'Open Rate (' + (data.click_through_rate.value ? data.click_through_rate.value : 0) + ' invites opened)'" :number="(data.click_through_rate.percent ? data.click_through_rate.percent : 0)"/>
				</div>
				<div class="col d-flex justify-content-center" v-if="!hideReviewSites">
					<percent-metric :title="(data.clicked_to_review_site.value ? data.clicked_to_review_site.value : 0) + ' Clicked to Review Site'"
									:number="(data.clicked_to_review_site.percent ? data.clicked_to_review_site.percent : 0)"/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    export default {
        props: {
            'data'           : {required: true},
            'expanded'       : {required: true},
            'hideReviewSites': {required: false, default: () => false}
        },

        methods: {
            toggleExpand() {
                this.$emit('update:expanded', !this.expanded);
            },
        }
    }
</script>
